<template>
  <div class="datePopup">
    <div class="datePopup_titleArea">
      <span class="title">更新站点</span>
      <i
        class="el-icon-close"
        @click="$emit('close')"
      />
    </div>
    <div class="datePopup_main">
      <el-date-picker
        v-model="timesr"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions1"
      />
      <div style="display:flex;align-items: baseline;">
        <div style="margin-right: 10px; font-size: 17px;">站点</div>
        <el-select v-model="value" placeholder="请选择站点" @change="channelShow">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.account_name===''?item.id:item.account_name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div v-if="!!value" style="display:flex;align-items: baseline;">
        <div style="margin-right: 10px; font-size: 17px;">渠道</div>
        <el-select
          v-model="keyword"
          filterable
          placeholder="请选择渠道"
          default-first-option
          loading-text="加载中"
          :loading="loading"
          @keyup.native="handleSelectChange"
        >
          <el-option
            v-for="item in optionschannel"
            :key="item.id"
            :label="item.wechat_name"
            :value="item.channel_id"
          />
        </el-select>
      </div>
    </div>

    <div class="datePopup_button">
      <el-button
        type="primary"
        @click="determine"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
import { getPlatformAccount, Report_formPreditChannel_list } from '@/api/providerAccountManagement/servicePorviderList.js'

export default {
  props: {
    datas: {
      type: Object,
      default: null
    },
    tableData: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      options: [],
      optionschannel: [],
      loading: false,
      value: '',
      timesr: '',
      pickerOptions1: {
        disabledDate(v) {
          return v.getTime() > new Date().getTime() - (86400000 - (24 * 60 * 60 * 1000))
        }
      },
      keyword: '',
      keywordname: '',
      timer: null
    }
  },
  mounted() {
    this.getData()
    // this.tableData.forEach(item => {
    //   const pattern = /点众/
    //   const hasMatch = pattern.test(item.name)
    //   if (hasMatch) {
    //     this.hasMatch = item.name === this.datas.name
    //   }
    // })
  },
  methods: {
    async handleSelectChange(e) {
      if (this.timer) {
        clearTimeout(this.timer) // 清除之前的计时器
      }
      this.loading = true
      this.timer = setTimeout(async() => {
        console.log(1, e.target.value)
        this.keywordname = e.target.value
        const data = await Report_formPreditChannel_list({
          platform_id: this.datas.id,
          keyword: this.keywordname,
          account_id: this.value
        })
        this.optionschannel = data.data
        this.loading = false
      }, 1000) // 等待1秒执行
    },
    async channelShow() {
      console.log(11, this.value, this.options)
      this.keyword = ''
      this.optionschannel = []
      if (this.optionschannel.length > 0) return
      const datas = await Report_formPreditChannel_list({
        platform_id: this.datas.id,
        keyword: this.keyword,
        account_id: this.value
      })
      this.optionschannel = datas.data
    },
    async getData() {
      const data = await getPlatformAccount(this.datas.id)
      this.options = data.data
    },
    determine() {
      console.log(this.value, 'this.value')
      if (!this.timesr) {
        this.$message({
          message: '请选择时间',
          type: 'warning'
        })
        return
      }
      if (!this.value) {
        this.timesr.push(0)
      } else {
        this.timesr.push(this.value)
      }
      if (!this.keyword) {
        this.timesr.push(0)
      } else {
        this.timesr.push(this.keyword)
      }
      console.log(this.timesr, this.value, !this.value, !!this.value, 'this.timesr')

      this.$emit('determine', this.timesr)
    }
  }
}
</script>

<style lang="less" scoped>
.el-select{
  margin-top:20px;
}
.datePopup {
  width: 500px;
  height: 400px;
  background-color: #fff;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  .datePopup_titleArea {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    .title {
    }
    i {
      cursor: pointer;
    }
  }

  .datePopup_main {
    flex-grow: 1;
    padding: 20px;
  }

  .datePopup_button {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
